interface LoadingCircleProps {
  hideLabel?: boolean;
  size?: number;
  inline?: boolean;
  variant?: "blue" | "gray";
}

export function LoadingCircle({ hideLabel = false, size = 48, inline = false, variant = "blue" }: LoadingCircleProps) {
  const spinnerColor = variant === "gray" ? "#9ca3af" : "#3ea7ff";
  
  const containerStyle = inline
    ? {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }
    : {
        minHeight: "100vh",
        width: "100%",
        display: "grid",
        placeItems: "center",
        backgroundColor: "#0b0b0b",
      };

  return (
    <div
      role="status"
      aria-busy="true"
      style={containerStyle as React.CSSProperties}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
        }}
      >
        <svg
          width={size}
          height={size}
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
        >
          {/* Track */}
          <circle
            cx="22"
            cy="22"
            r="18"
            stroke="rgba(255,255,255,0.12)"
            strokeWidth="4"
          />
          {/* Spinner arc */}
          <circle
            cx="22"
            cy="22"
            r="18"
            stroke={spinnerColor}
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="80 120"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 22 22"
              to="360 22 22"
              dur="0.9s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
        {!hideLabel && (
          <div
            style={{
              color: "#e6e6e6",
              fontSize: 13,
              letterSpacing: "0.01em",
              opacity: 0.9,
            }}
          >
            Loading
          </div>
        )}
      </div>
    </div>
  );
}
